<template>
  <div class="d-flex align-items-center min-vh-100">
    <CContainer fluid>
      <CRow class="justify-content-center">
        <CCol md="4">
          <CCard class="mx-2 mb-0">
            <CCardBody class="p-4">
              <CForm>
                <h1>Lupa Password</h1>
                <p class="text-muted">Reset Password Akun WebSMSmu</p>
                <CAlert
                  color="success"
                  closeButton
                  :show.sync="alert.show"
                >
                  {{ alert.content }}
                </CAlert>
                <CInput 
                  type="email"
                  placeholder="Email" 
                  v-model="data.email"
                  :invalid-feedback="errors.email ? errors.email[0]:''"
                  :is-valid="errors.email ? false:null"
                >
                  <template #prepend-content>@</template>
                </CInput>
                <ButtonLoader 
                  :loading="loading.submit" 
                  :styled="'btn btn-success btn-block'" 
                  @click.native="submit()">
                    Reset Sekarang
                </ButtonLoader>
              </CForm>
            </CCardBody>
            <CCardFooter class="p-4">
              <CRow>
                <CCol col="12" class="text-center">
                  <p>Sudah Punya Akun WebSMS?</p>
                  <CButton color="primary" class="px-4" @click="$router.push({name: 'Login'})">Masuk</CButton>
                </CCol>
              </CRow>
            </CCardFooter>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import $axios from './../../api.js'
export default {
  name: 'Register',
  data(){
    return{
      alert:{
        show: false,
        content: ''
      },
      loading:{
        submit: false
      },
      data:{
        email: ''
      }
      
    }
  },
  created(){
    if (this.isAuth) {
      this.$router.push({ name: 'Home' })
    }
  },
  computed:{
    ...mapState(['errors']),
    ...mapGetters(['isAuth']),
  },
  methods:{
    submit(){
      this.$store.commit('CLEAR_ERRORS')
      this.loading.submit = true
      $axios.post('/auth/forget', this.data)
      .then((response) => {
        this.loading.submit = false
        this.alert = {
          show: true,
          content: 'Reset password berhasil, password baru dikirimkan ke email terdaftar.'
        }
      })
      .catch((error) => {
        this.loading.submit = false
        if (error.response.status == 422) {
          this.$store.commit('SET_ERRORS', error.response.data.errors, { root: true })
        }
      })
    }
  },
  destroyed(){
    this.$store.commit('CLEAR_ERRORS')
  }
}
</script>
